<template>
  <div class="booking-menu">
    <ul style="cursor: pointer; padding-left: 0px !important">
      <li class="padding-li" key="id">
        <p>ID <b>{{booking.id}}</b>
          <v-icon small color="blue" @click="copyToClipBoard(booking.id)" class="mx-2">mdi-content-copy</v-icon>
          <v-icon small @click="goToBooking(booking.id)" color="blue">mdi-open-in-new</v-icon>
        </p>
      </li>
      <li class="padding-li" key="copy" @click="copy">
        <p>Copy</p>
      </li>
      <li class="padding-li" key="edit" @click="edit">
        <p>Edit</p>
      </li>
      <li
        v-if="booking.state == 'booked'"
        class="padding-li"
        key="assign"
        @click="assign"
      >
        <p>Assign</p>
      </li>
<!--      <li-->
<!--        v-if="booking.state == 'accepted' && !booking.pob_time && !booking.arrived_time"-->
<!--        class="padding-li"-->
<!--        key="assign"-->
<!--        @click="openDriverActiveJobsDialog"-->
<!--      >-->
<!--        <p>Driver Active Jobs</p>-->
<!--      </li>-->
      <li
        v-if="booking.state == 'accepted'"
        class="padding-li"
        key="reassign"
        @click="reassign"
      >
        <p>Reassign</p>
      </li>
      <li
        v-if="(booking.state == 'accepted' || (booking.preassigned_driver != null && booking.state == 'booked') ) && allowFinish"
        class="padding-li"
        key="finish"
        @click="finish"
      >
        <p>Finish Trip</p>
      </li>
      <li
        v-if="booking.state == 'accepted' || booking.state == 'cancelled'"
        class="padding-li"
        key="recover"
        @click="recoverTrip()"
      >
        <p>Recover Trip</p>
      </li>
      <li
        v-if="booking.state == 'unconfirmed' && booking.availability_status == 'busy'"
        class="padding-li"
        key="confirm"
        @click="confirmTrip()"
      >
        <p>Confirm Trip</p>
      </li>
      <li
        v-if="booking.state == 'unconfirmed' && booking.availability_status == 'unavailable'"
        class="padding-li"
        key="confirm"
        @click="rebookNoDriverAvailable()"
      >
        <p>Recover</p>
      </li>
      <li
        class="padding-li"
        key="cancel"
        @click="cancelTrip()"
        v-if="booking.state != 'cancelled' && booking.state != 'completed' || (booking.state == 'unconfirmed' && ((booking.booking_type != 'phone') && booking.booking_type != 'website') && (booking.availability_status == 'busy' || !booking.availability_status))"
      >
        <p>Cancel Trip</p>
      </li>
      <li
        class="padding-li"
        key="cancel"
        @click="noDriverAvailableForUnconfirmedBooking()"
        v-if="booking.state == 'unconfirmed' && booking.availability_status == 'busy' && ((booking.booking_type == 'phone') || booking.booking_type == 'website') "
      >
        <p>No Driver Available</p>
      </li>
      <li class="padding-li" key="call_customer" @click="close()">
        <a :href="'tel:' + formatNumber(booking.customer_number)">
          <p>Call Customer {{ formatNumber(booking.customer_number) }}</p>
        </a>
      </li>
      <li class="padding-li" key="copy_number" @click="copyCustomerNumber( formatNumber(booking.customer_number) )">
          <p>Copy Customer Number {{ formatNumber(booking.customer_number) }}</p>
      </li>
      <li
        v-if="booking.currentTaxi != null"
        class="padding-li"
        key="call_driver"
        @click="close()"
      >
        <a
          :href="
            'tel:' + formatNumber(booking.currentTaxi.driver.contact_number)
          "
        >
          <p>
            Call Driver
            {{ formatNumber(booking.currentTaxi.driver.contact_number) }}
          </p>
        </a>
      </li>
      <li
        v-if="booking.driver != null"
        class="padding-li"
        key="call_driver"
        @click="close()"
      >
        <a :href="'tel:' + formatNumber(booking.driver.contact_number)">
          <p>Call Driver {{ formatNumber(booking.driver.contact_number) }}</p>
        </a>
      </li>
      <li
        v-if="booking.currentTaxi == null && booking.preassigned_driver != null"
        class="padding-li"
        key="call-preassigned-driver"
        @click="close()"
      >
        <a
          :href="
            'tel:' +
            formatNumber(booking.preassigned_driver.driver.contact_number)
          "
        >
          <p>
            Call Preassigned Driver
            {{ formatNumber(booking.preassigned_driver.driver.contact_number) }}
          </p>
        </a>
      </li>
      <li
        v-if="booking.state == 'accepted'"
        class="padding-li"
        key="message"
        @click="message(booking.currentTaxi)"
      >
        <p>Message Driver</p>
      </li>
      <li
        v-if="booking.currentTaxi == null && booking.preassigned_driver != null"
        class="padding-li"
        key="message_preassigned_driver"
        @click="messageNumber(booking.preassigned_driver.driver.contact_number)"
      >
        <p>SMS Message Preassigned Driver</p>
      </li>
      <li
        v-if="booking.state == 'accepted'"
        class="padding-li"
        key="message_driver"
        @click="messageNumber(booking.currentTaxi.driver.contact_number)"
      >
        <p>SMS Message Driver</p>
      </li>
    </ul>
    <v-divider></v-divider>
    <v-layout
      v-if="mode == null && booking.offer_taxis != null"
      class="confirm-container"
    >
      <v-flex grow>
        <v-btn
          v-if="!loading"
          @click="cancelOffer()"
          color="red"
          class="text-none"
          dark
          >Cancel Offer</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout
      style="width: 100%"
      class="confirm-container"
      v-if="mode == 'finish'"
    >
      <v-flex grow>
        <v-btn
          v-if="!loading"
          @click="confirmFinish()"
          color="green"
          class="text-none"
          dark
          >Confirm Finish</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout
      style="width: 100%"
      class="confirm-container"
      v-if="mode == 'cancel'"
    >
      <v-flex grow>
        <v-btn
          v-if="!loading"
          @click="confirmCancel()"
          color="green"
          class="text-none"
          dark
          >Confirm Cancel</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout
      style="width: 100%"
      class="confirm-container"
      v-if="mode == 'recover'"
    >
      <v-flex grow>
        <v-checkbox v-model="manualAssign" label="Hold back"></v-checkbox>
        <v-btn
          v-if="!loading"
          @click="confirmRecover()"
          color="green"
          class="text-none"
          dark
          >Confirm Recover</v-btn
        >
      </v-flex>
    </v-layout>
    <v-dialog v-model="messageDialog" width="600px">
      <MessageDriverDialog
        :smsMode="smsMode"
        @sent="messageDialog = false"
        :taxi="taxi"
        :number="number"
      />
    </v-dialog>
    <v-dialog v-model="cancelBookingDialog" width="600px" persistent>
      <CancelBooking @closeCancelDialog="cancelBookingDialog = false" @cancelled="cancelBookingDialog = false" :booking="booking"></CancelBooking>
    </v-dialog>
    <div class="text-center">
      <v-dialog
        v-model="driverActiveJobsDialog"
        width="1000"
      >
        <v-card v-if="booking.currentTaxi && booking.currentTaxi.driver">
          <v-card-title class="text-h5 grey lighten-2">
            Active Jobs <v-chip color="primary" small class="mx-3">
            <v-icon small class="ma-1">mdi-car</v-icon>
            {{booking.currentTaxi.driver.callsign}}
          </v-chip>
            <v-spacer></v-spacer>
            <v-icon @click="driverActiveJobsDialog = false">mdi-close</v-icon>
          </v-card-title>
        
          <v-card-text>
            <DriverActiveJobsList @closeActiveJobsDialog="driverActiveJobsDialog = false" :driver="booking.currentTaxi.driver"></DriverActiveJobsList>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";
import CancelBooking from '../../booking/CancelBooking'
import DriverActiveJobsList from '@/components/booking/active_jobs/DriverActiveJobsList'

export default {
  components: {
    DriverActiveJobsList,
    CancelBooking,
    MessageDriverDialog,
  },
  name: "BookingMenu",
  props: {
    booking: Object,
    allowFinish: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      driverActiveJobsDialog: false,
      cancelBookingDialog: false,
      mode: null,
      loading: false,
      manualAssign: true,
      messageDialog: false,
      taxi: null,
      smsMode: false,
      number: "",
    };
  },
  mounted: function () {},
  methods: {
    confirmTrip () {
      this.$swal.fire({
        title: 'Are you sure you want to confirm this trip?',
        text: "This trip will be booked and you can assign to driver",
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonColor: this.$colorsConfig.getUnconfirmedBookingColor(),
        cancelButtonColor: '#e85b5b',
        denyButtonColor: '#3085d6',
        confirmButtonText: 'Yes, confirm it!',
        denyButtonText: `Update Details`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('unconfirmedBooking/confirm', this.booking.id)
          this.$swal.fire(
            'Confirmed!',
            'The trip is now booked for customer',
            'success'
          )
        } else if (result.isDenied) {
          this.$swal.fire('Please update the trip details. When you press update, it will be confirmed', '', 'info')
          this.$store.commit('unconfirmedBooking/setUnconfirmedUpdate', true)
          this.edit()
        }
      })
    },
    rebookNoDriverAvailable () {
      this.$swal.fire({
        title: 'Are you sure you want to rebook this trip?',
        text: "This trip will be booked and you can assign to driver",
        icon: 'warning',
        showDenyButton: true,
        showConfirmButton: false,
        showCancelButton: true,
        confirmButtonColor: this.$colorsConfig.getUnconfirmedBookingColor(),
        cancelButtonColor: '#e85b5b',
        denyButtonColor: '#3085d6',
        denyButtonText: `Update Details`,
      }).then((result) => {
        if (result.isDenied) {
          this.$snackbar.show('Please update the trip details. When you press update, it will be confirmed')
          this.$store.commit('unconfirmedBooking/setUnconfirmedUpdate', true)
          this.edit()
        }
      })
    },
    noDriverAvailableForUnconfirmedBooking () {
      this.$swal.fire({
        title: 'Are you sure you want to cancel this trip?',
        text: "This trip will be marked as no driver available",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.$colorsConfig.getUnconfirmedBookingColor(),
        cancelButtonColor: '#e85b5b',
        confirmButtonText: 'Yes, confirm it!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('unconfirmedBooking/cancel', this.booking.id).then(res => {
            this.$swal.fire(
              'Confirmed!',
              'The trip is now completely cancelled',
              'success'
            )
          })
        }
      })
    },
    goToBooking(id) {
      return window.open('/bookings/' + id, '_blank')
    },
    openDriverActiveJobsDialog () {
      this.$store.dispatch('activeJob/getDriverActiveJobs', this.booking.currentTaxi.driver.id)
      this.driverActiveJobsDialog = true
    },
    copyToClipBoard (content) {
      if (content) {
        navigator.clipboard.writeText(content);
      }
    },
    copyCustomerNumber: function(number) {
      navigator.clipboard.writeText(number)
      this.close();
    },
    message: function (taxi) {
      console.log("Message");
      if (taxi.driver.chat_enabled == true) {
        this.$store.state.driverToMessage = taxi.driver.id;
        this.$store.state.driverToMessageName = taxi.driver.name;
        this.close();
      } else {
        this.taxi = taxi;
        this.messageDialog = true;
      }
    },
    messageNumber: function (number) {
      this.smsMode = true;
      this.number = number;
      this.messageDialog = true;

      this.close();
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    close: function () {
      this.mode = null;
      this.$emit("close");
    },
    finish: function () {
      this.mode = "finish";
    },
    assign: function () {
      this.$emit("assign", null);
      this.close();
    },
    reassign: function () {
      this.$emit("reassign", null);
      this.close();
    },
    track: function () {
      this.$emit("track", null);
    },
    copy: function () {
      console.log(this.booking);
      this.$emit("copy", null);
      this.close();
    },
    edit: function () {
      this.$emit("edit", null);
      this.close();
    },
    reset: function () {
      console.log("Reset");
      this.mode = null;

      this.close();
    },
    recoverTrip: function () {
      this.manualAssign = true;
      this.mode = "recover";
    },
    cancelTrip: function () {
      this.cancelBookingDialog = true
      // this.mode = "cancel";
    },
    confirmFinish: function () {
      console.log("Cancel called");

      var url = `${this.$store.state.apiUrl}/booking/finish/${this.booking.id}`;

      var reset = this.reset;
      this.loading = true;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          vm.loading = false;

          if (res.data.error == "no_error") {
            reset();
            console.log("Finished trip");
          } else {
            console.log("Failed to finish booking");

            var error = res.data.error;

            if (error == "no_booking") {
              alert("This booking does not exist");
            } else if (error == "unable_to_set_final_destination") {
              alert(
                "Unable to set final destination for booking - please book manually"
              );
            } else if (error == "cost_too_low") {
              alert(res.data.message);
            } else if (error == "booking_in_wrong_state") {
              alert("Booking is in wrong state");
            } else if (error == "card_error") {
              alert("This booking has a card error");
            } else if (error == "auth_required") {
              alert("This booking requires card authorisation by customer");
            } else {
              alert(res.data.error);
            }
          }
        })
        .catch(function (err) {
          vm.loading = false;
          console.error(err);
        });
    },
    confirmCancel: function () {
      console.log("Cancel called");

      var url = `${this.$store.state.apiUrl}/booking/cancel/${this.booking.id}`;

      var reset = this.reset;
      this.loading = true;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          vm.loading = false;
          if (res.data.error == "no_error") {
            reset();
            console.log("Cancelled trip");
          } else {
            console.log("Failed to cancel booking");
          }
        })
        .catch(function (err) {
          vm.loading = false;
          console.error(err);
        });
    },
    cancelOffer: function () {
      console.log("Recover called");

      var url = `${this.$store.state.apiUrl}/overwatch/cancelOffer?booking_id=${this.booking.id}`;

      this.loading = true;
      var reset = this.reset;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          vm.loading = false;

          if (res.data.error == "no_error") {
            reset();
            console.log("Cancelled offer for trip");
          } else {
            console.log("Failed to cancel offer for booking");
          }
        })
        .catch(function (err) {
          vm.loading = false;
          console.error(err);
        });
    },
    confirmRecover: function () {
      console.log("Recover called");

      var url = `${this.$store.state.apiUrl}/booking/recover/${this.booking.id}?manual_dispatch=${this.manualAssign}`;

      this.loading = true;
      var reset = this.reset;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          vm.loading = false;

          if (res.data.error == "no_error") {
            reset();
            console.log("Recovered trip");
          } else {
            console.log("Failed to recover booking");
          }
        })
        .catch(function (err) {
          vm.loading = false;
          console.error(err);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.booking-menu {
  background-color: white;
}

.disabled-list-item {
  pointer-events:none; //This makes it not clickable
  opacity:0.6;         //This grays it out to look disabled
}

.confirm-container {
  padding: 12px;
}
</style>
